import icAddSquare from 'assets/images/ic-add-square.svg'
import icTrash from 'assets/images/ic-trash.svg'
import { Button } from 'avo-ui'
import ModalDelete from 'components/commons/modal-delete'
import Search from 'components/commons/search'
import Table from 'components/commons/table'
import { TABLE_BRAND_NOMINATION } from 'configs/award/configTableBrandNomination'
import { ACTION_TYPE } from 'constants/constant'
import { FormBrandNomination } from './FormBrandNomination'

export const BrandNomination = ({
    dataList,
    brandNominationDetail,
    modal,
    setShowModal,
    query,
    onChangeQuery,
    isFormValid,
    selectedIds,
    onSelectItemHandler,
    onActionRow,
    onChangeForm,
    onHideForm,
    onSubmit,
    onDelete,
    isLoading,
    isDeleting,
    isCreating,
    isUpdating,
    isResetSelectedItem,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex gap-x-3'}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        disabled={!selectedIds?.length}
                        onClick={() => onActionRow({ actionType: ACTION_TYPE.DELETE })}
                    />
                </div>
                <Button
                    type={'outline'}
                    icon={icAddSquare}
                    title={'Create Brand Nomination'}
                    onClick={() => onActionRow({ actionType: ACTION_TYPE.CREATE })}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_BRAND_NOMINATION.name}
                columns={TABLE_BRAND_NOMINATION.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={'Are You Sure to Delete Brand Nomination'}
                    totalData={selectedIds?.length}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
            {modal?.form && (
                <FormBrandNomination
                    show={modal?.form}
                    onHideForm={onHideForm}
                    dataBrandNomination={brandNominationDetail}
                    isLoading={isCreating || isUpdating}
                    isDisabled={!isFormValid()}
                    onChangeForm={onChangeForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
